import React from 'react';
import { DownloadButton } from 'components/DownloadButton';
import { Distributor } from 'logic/apiCalls';
import { LineChartButton } from 'components/LineChartButton';

type DistributorUsageEntryProps = {
    distributor: Distributor,
    handleDownload: (distributorToUpdate: Distributor) => void,
    handleLineChart: (distributorToUpdate: Distributor) => void,
}

export const DistributorUsageEntry = ({ distributor, handleDownload, handleLineChart } : DistributorUsageEntryProps) => {
    return (
        <tr key={distributor.id} className={`d-flex`}>
            <td className="col-3">{distributor.id}</td>            
            <td className="col-3">{distributor.label}</td>            
            <td className="col-3">{distributor.azureTenantId}</td>                    
            <td className="col-3">
                <LineChartButton className='float-right mr-3' onClick={() => handleLineChart(distributor)}/>
                <DownloadButton className='float-right mr-3' onClick={() => handleDownload(distributor)}/>
            </td>
        </tr>
    )
}